module.exports = __webpack_public_path__ + "img/accident_primary_100.4f717ac0.svg";